import { NgModule } from '@angular/core';
import { OrderDetailService } from '@cutting/main/order/order-detail/order-detail.service';
import { CloudSharedLibModule, CuttingPanelListModule } from 'cloud-shared-lib';

@NgModule({
  imports: [CuttingPanelListModule.forRoot(OrderDetailService), CloudSharedLibModule],
  exports: [CuttingPanelListModule, CloudSharedLibModule],
})
export class OrderDetailModule {}
